import { ThemeProvider } from 'styled-components';
import { QueryClientProvider, QueryClient } from 'react-query';
import { useForm } from 'react-hook-form';
import axios from 'axios';

import { theme } from '../../assets/style/theme';
import defaultTheme, { responsiveValue } from '../../assets/style/defaultTheme';
import GrobalStyle from '../../assets/style/global-style';

import logow from '../../assets/images/logo_w.png';
import logowEn from '../../assets/images/logo_w_en.png';
import Nav from '../SiteHeader/Nav';
import { SiteFooterSection } from './style';
import FooterInfo from './FooterInfo';

import { FootNavSection, SnsNavSection } from '../SiteHeader/Nav/style';
import { Box, Button, ChakraProvider, extendTheme, Flex, FormControl, FormErrorMessage, Heading, Image, Input, Text, useToast } from '@chakra-ui/react';


const queryClient = new QueryClient();
const chakraTheme = extendTheme(defaultTheme);

function NewsletterSubscription() {
  const toast = useToast();
  const isEnglish = window.__LANG__ === 'en';
  const labels = isEnglish
    ? {
        title: 'Get various updates from koreaSHE Foundation!',
        newsletterTitle: "Newsletter & SHE's view Magazine",
        newsletterDescription: "We'll deliver news from the Forest & Sharing Foundation and expert insights from SHE's view.",
        collectiveTitle: 'Single-Person Household Collective Newsletter',
        collectiveDescription: "We'll deliver research materials and updates needed for single-person household policy and on-the-ground practice.",
        namePlaceholder: 'Enter your name',
        emailPlaceholder: 'Enter your email address',
        nameRequired: 'Name is required.',
        emailRequired: 'Email is required.',
        subscribe: 'Subscribe',
      }
    : {
        title: '숲과나눔의 다양한 소식을 받아보세요!',
        newsletterTitle: '뉴스레터 & SHE’s view 매거진',
        newsletterDescription: "숲과나눔 재단 소식과 SHE's view의 전문 인사이트를 전해드려요.",
        collectiveTitle: '1인가구컬렉티브 뉴스레터',
        collectiveDescription: '1인가구 정책과 현장에 필요한 연구자료 & 소식을 전해드려요.',
        namePlaceholder: '이름을 입력해주세요',
        emailPlaceholder: '이메일주소를 입력해주세요',
        nameRequired: '이름은 필수 항목입니다.',
        emailRequired: '이메일은 필수 항목입니다.',
        subscribe: '구독하기',
      };
  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
  } = useForm();
  const {
    handleSubmit: handleCollectiveSubmit,
    register: registerCollective,
    formState: { errors: collectiveErrors, isSubmitting: isCollectiveSubmitting },
  } = useForm();

  const submitSubscription = async (values: any, stibeeEndpoint: string) => {
    const formData = new FormData();
    formData.append('email', values.email);
    formData.append('name', values.name);
    const res = await axios.post(stibeeEndpoint, formData);
    const msg = res.data.split('<p>')[1].split('</p>')[0];
    toast({
      description: msg,
      status: 'success',
      position: 'top',
    });
  };

  const onSubscribe = (values: any) => {
    return submitSubscription(values, 'https://stibee.com/api/v1.0/lists/kNI7z7yQacvThCROHW3T3dPVca-T/public/subscribers');
  };

  const onCollectiveSubscribe = (values: any) => {
    return submitSubscription(values, 'https://stibee.com/api/v1.0/lists/fr89x1HSW84meZHJntvJFGYYIhFYoQ==/public/subscribers');
  };

  return (
    <Box id="newsletter" pt="16" pb="16" px={{ base: '4%', lg: '0' }} backgroundImage="/images/main/newsletter_bg.png" backgroundRepeat="no-repeat" backgroundPosition="50% 50%" backgroundSize="cover">
      <Box maxW="1200" margin="0 auto">
        <Flex justify="space-between" align={{ base: 'start', lg: 'center' }} direction="column" gap={10}>
          <hgroup>
            <Heading size="4xl" color="b.wh" lineHeight="1.4">
              {labels.title}
            </Heading>
          </hgroup>

          <Flex direction={{ base: 'column', lg: 'row' }} gap={8} justify="center" align={{ base: 'start', lg: 'center' }} w="100%">
            <Flex direction="column" gap={4} border="1px solid" borderColor="b.wh" borderRadius="16px" bg="rgba(255, 255, 255, 0.08)" p={5}>
              <Flex direction="column" >
                <Heading size="2xl"  color="b.wh" lineHeight="1.4">{labels.newsletterTitle}</Heading>
                <Text color="b.wh" fontSize="md" lineHeight="1.4">{labels.newsletterDescription}</Text>
              </Flex>
              <form name="subscribe" onSubmit={handleSubmit(onSubscribe)}>
                <Flex direction={responsiveValue.flexBoxDirection} alignItems="start">
                  <FormControl id="name"  pb={{ base: '2', lg: '0' }} isInvalid={!!errors.name}>
                    <Input size="lg" w={{ base: '200px', lg: '140px' }} type="text" placeholder={labels.namePlaceholder} {...register('name', { required: true })} />
                    <FormErrorMessage color="b.wh">{labels.nameRequired}</FormErrorMessage>
                  </FormControl>
                  <FormControl id="email" pb={{ base: '2', lg: '0' }} pl={{ base: '0', md: '2' }} isInvalid={!!errors.email}>
                    <Input size="lg" w={{ base: '300px', lg: '260px' }} type="email" placeholder={labels.emailPlaceholder} {...register('email', { required: true })} />
                    <FormErrorMessage color="b.wh">{labels.emailRequired}</FormErrorMessage>
                  </FormControl>
                  <FormControl pl={{ base: '0', md: '2' }}>
                    <Button type="submit" size="lg" fontSize="md" colorScheme="dgr" borderRadius="8" isLoading={isSubmitting}>
                      {labels.subscribe}
                    </Button>
                  </FormControl>
                </Flex>
              </form>
            </Flex>

            <Flex direction="column" gap={4} border="1px solid" borderColor="b.wh" borderRadius="16px" bg="rgba(255, 255, 255, 0.08)" p={5}>
              <Flex direction="column" >
                <Heading size="2xl"  color="b.wh" lineHeight="1.4">{labels.collectiveTitle}</Heading>
                <Text color="b.wh" fontSize="md" lineHeight="1.4">{labels.collectiveDescription}</Text>
              </Flex>
              <form name="collective-subscribe" onSubmit={handleCollectiveSubmit(onCollectiveSubscribe)}>
                <Flex direction={responsiveValue.flexBoxDirection} alignItems="start">
                  <FormControl id="collective-name" pb={{ base: '2', lg: '0' }} isInvalid={!!collectiveErrors.name}>
                    <Input size="lg" w={{ base: '200px', lg: '140px' }} type="text" placeholder={labels.namePlaceholder} {...registerCollective('name', { required: true })} />
                    <FormErrorMessage color="b.wh">{labels.nameRequired}</FormErrorMessage>
                  </FormControl>
                  <FormControl id="collective-email" pb={{ base: '2', lg: '0' }} pl={{ base: '0', md: '2' }}  isInvalid={!!collectiveErrors.email}>
                    <Input size="lg" w={{ base: '300px', lg: '260px' }} type="email" placeholder={labels.emailPlaceholder} {...registerCollective('email', { required: true })} />
                    <FormErrorMessage color="b.wh">{labels.emailRequired}</FormErrorMessage>
                  </FormControl>
                  <FormControl pl={{ base: '0', md: '2' }}>
                    <Button type="submit" size="lg" fontSize="md" colorScheme="dgr" borderRadius="8" backgroundColor="orange.500" _hover={{ backgroundColor: 'orange.600' }} isLoading={isCollectiveSubmitting}>
                      {labels.subscribe}
                    </Button>
                  </FormControl>
                </Flex>
              </form>
            </Flex>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
}

function SiteFooter() {
  const onHover = () => {
    // Footer navigation does not use hover state.
  }

  const onChangeLink = (e:any) => {		
    window?.open(e.target.value, '_blank')?.focus();
  }

  const onClickNewsletter = () => {
    document.getElementById('newsletter')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const isEnglish = window.__LANG__ === 'en';

  return (
    <>
    <ThemeProvider theme={theme}>
    <GrobalStyle />
    <ChakraProvider theme={chakraTheme}>
    <QueryClientProvider client={queryClient}>
      <NewsletterSubscription />
      <SiteFooterSection>
        <section>
          <nav className="nav">
            <FootNavSection>
              <Nav slug={isEnglish ? 'footnav_en' : 'footnav'} onHover={onHover} />
            </FootNavSection>
            
            <select onChange={onChangeLink} value="">
              <option value="">
                {isEnglish ? 'Regulatory Agency for Public Interest Violations' : '공익위반사항 관리감독 기관'}
              </option>
              <option value="https://www.acrc.go.kr/">국민권익위원회 </option>
              <option value="http://www.me.go.kr/">환경부</option>
              <option value="https://www.nts.go.kr/">국세청</option>
            </select>
          </nav>

          <div className="info">
            <section>
              <h1 className="logo">
                <img src={isEnglish ? logowEn : logow} alt="재단법인 숲과나눔" width="216" />
              </h1>
              <SnsNavSection>
                <Nav slug="sns" type="icon" target="_blank" onHover={onHover} />
              </SnsNavSection>
            </section>
            <FooterInfo />
          </div>
        </section>
        {
          !isEnglish && (
            <>
            <div className="floating-banner">
              <a href="/donation">
                <Image src="/images/main/fl_mo_do.png" alt="후원하기" />
              </a>
              <button type="button" onClick={onClickNewsletter} aria-label="뉴스레터 구독 영역으로 이동">
                  <Image src="/images/main/fl_mo_nl.png" alt="뉴스레터" />
              </button>
              <div className="footer-social-banner">
                <a href="https://blog.naver.com/korea_she" target="_blank" rel="noreferrer" aria-label="Naver Blog"><i className="xi-naver"></i></a>
                <a href="https://www.facebook.com/koreashe" target="_blank" rel="noreferrer" aria-label="Facebook"><i className="xi-facebook"></i></a>
                <a href="http://www.instagram.com/korea.she" target="_blank" rel="noreferrer" aria-label="Instagram"><i className="xi-instagram"></i></a>
                <a href="https://www.youtube.com/channel/UCrbYikiqpJAXv8xmYhzV-yw" target="_blank" rel="noreferrer" aria-label="YouTube"><i className="xi-youtube-play"></i></a>
              </div>
            </div>

            <div className="floating-banner-mobile">
              <a href="/donation">
                <Image src="/images/main/fl_mo_do.png" alt="후원하기" />
              </a>
              <button type="button" onClick={onClickNewsletter} aria-label="뉴스레터 구독 영역으로 이동">
                  <Image src="/images/main/fl_mo_nl.png" alt="뉴스레터" />
              </button>
            </div>
            </>
          )
        }
      </SiteFooterSection>
    </QueryClientProvider>
    </ChakraProvider>
    </ThemeProvider>
    </>
  );
}

SiteFooter.defaultProps = {
};

export default SiteFooter;
